<div class="ui-g-12">

  <div class="ui-g">
    <div class="ui-g-12 ui-md-6 ui-sm-12" *ngIf="data != null">

      <p-table [value]="datatablePromo" class="overview-table">

        <ng-template pTemplate="body" let-col>
          <tr>
            <td class="number-column"><strong>{{ col.col1 | translate }}</strong></td>
            <td class="number-column">{{ col.col2 }}</td>
          </tr>
        </ng-template>

      </p-table>


      <h1>{{ translations.prodotti_promo | translate }}</h1>

      <p-table [value]="datatableProduct" class="overview-table">

        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'descrizione_articolo'">
              <span class="sortableCol"><strong>{{ translations.descrizione_articolo | translate }}</strong></span>
              <p-sortIcon class="sortableIcon" [field]="'descrizione_articolo'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'prezzo_base'">
              <span class="sortableCol"><strong>{{ translations.prezzo_base | translate }}</strong></span>
              <p-sortIcon class="sortableIcon" [field]="'prezzo_base'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'descrizione_meccanica'">
              <span class="sortableCol"><strong>{{ translations.descrizione_meccanica | translate }}</strong></span>
              <p-sortIcon class="sortableIcon" [field]="'descrizione_meccanica'"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-col>
          <tr>
            <td class="number-column">{{ col.descrizione_articolo }}</td>
            <td class="number-column">{{ col.prezzo_base }}</td>
            <td class="number-column">{{ col.descrizione_meccanica }}</td>
          </tr>
        </ng-template>

      </p-table>

    </div>

    <div class="ui-g-12 ui-md-6 ui-sm-12">
      <div class="ui-g">
        <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-6 ui-sm-6">
          <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [options]="indicator.options"></app-infobox>
        </div>
      </div>
    </div>
  </div>

  <p-dialog header="Error" [(visible)]="promoError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
    <p>{{ 'promo.selectOneErrorMsg' | translate }}</p>
    <div class="ui-dialog-footer">
      <button pButton type="button" class="slim red-button" (click)="toogleErrorPromoDialog()" label="Ok"></button>
    </div>
  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/analysis/anagraphic/promo-anagraphic.component.html